import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root'
}) 
export class WebsocketsService {

  public socketStatus = false;
  public idPregunta = '';
  public pregunta = '';
  public respuestas = 4;
  public arrRespuestas = [];
  public idEncuesta = '';
  public respuestaActual = "";

  public correctas = 0;
  public incorrectas = 0;
  public sinContestar = 0;

  constructor(
    private socket: Socket
  ) {
    this.checkStatus(); 
   }
  checkStatus(){
    this.socket.on('connect', () => {
      this.socketStatus = true;
      console.log("Conectado al servidor ");
    });
    this.socket.on('disconnect', () => {
      this.socketStatus = false;
      console.log("Desconectado del servidor ");
    });
  }
  
  emit( evento: string, payload?: any, callback?: Function ) {

    console.log('Emitiendo', evento);
    // emit('EVENTO', payload, callback?)
    this.socket.emit( evento, payload, callback );

  }

  listen( evento: string ) {
    return this.socket.fromEvent( evento );
  }

  
  crearEncuesta() {
    return this.listen('iniciar-encuesta');
  }
  getPregunta() {
    return this.listen('pregunta-vista');
  }
  getApagarPregunta() {
    return this.listen('pregunta-ocultar');
  }
  cerrarEncuesta() {
    return this.listen('encuesta-terminar');
  }
  iniciarPreguntas(){ 
    this.correctas = 0;
    this.incorrectas = 0;
    this.sinContestar = 0;
  }
}
